module.exports = __webpack_public_path__ + "media/images/price_list/reference-3-9bc8181c670cf2171dd0267b72d42da5.webp";